import SPopup from './src/main';

export default SPopup;
